import React, { createContext, useState } from 'react';

import OrgRoleHierarchyData from './OrgRoleHierarchyData';

export const OrgRoleHierarchyStateContext = createContext();

const OrgRoleHierarchyContextProvider = ({ children }) => {
  const stateHook = useState(OrgRoleHierarchyData.INITIAL_STATE);

  return (
    <OrgRoleHierarchyStateContext.Provider value={stateHook}>
      {children}
    </OrgRoleHierarchyStateContext.Provider>
  );
};

export default OrgRoleHierarchyContextProvider;